const callLogsHeadersReducer = (
    state = {
      data: [],
    },
    action: {
      type: "SET_CALLLOGS_HEADER_LIST";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_CALLLOGS_HEADER_LIST":
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default callLogsHeadersReducer;
  